import ImageComponent from './ImageComponent';

export default ImageComponent;
